import * as departmentResource from '@/modules/department/department.resource';
import { formatToTimeAgo } from '@/helpers/date';

export function fetchDepartments(pagination = {}) {
  return new Promise((resolve, reject) =>
    departmentResource
      .fetchDepartments(pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => reject(err)));
}

export function getDepartmentById(id) {
  return new Promise((resolve, reject) =>
    departmentResource
      .getDepartmentById(id)
      .then(({ data }) => {
        resolve({
          id: data.id,
          name: data.name,
          description: data.description,
          deleted: data.deleted,
          updated_at: formatToTimeAgo(data.updated_at),
        });
      })
      .catch(err => reject(err)));
}

export function saveDepartment(department) {
  const errors = null;
  return new Promise((resolve, reject) =>
    (errors ? reject(errors) : getDepartmentSaveAction(department)(department)
      .then(({ data }) => resolve(data))
      .catch(err => reject(err))));
}

export function removeDepartment(department) {
  return departmentResource.removeDepartment(department.id);
}

function getDepartmentSaveAction(department) {
  return department.id ? departmentResource.updateDepartment : departmentResource.saveNewDepartment;
}
